import GA_EVENTS from './ga_constants';
import { setBehaviourEvent } from './ga_interface';
import PageTypeFactory from '../../page/get_page_type';

class AddressAnalytics {
    static setPostcode(beforeUnload) {
        const category = GA_EVENTS.postcode.category;
        const action = GA_EVENTS.postcode.actions.entered;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({ category, action, label, beforeUnload });
    }
}

export default AddressAnalytics;